import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import Table from "../../extra/Table";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import {
  deleteFakeSeller,
  getFakeSeller,
  sellerIsLive,
  setOfflineStatus,
} from "../../store/fake Seller/fakeSeller.action";
// import SellerNotification from "./SellerNotification";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { warning } from "../../../util/Alert";
import { colors } from "../../../util/SkeletonColor";

import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IconPlayerPlayFilled } from "@tabler/icons-react";
import { MdOutlineLiveTv } from "react-icons/md";
import LazyImage from "../../../common/ImageFallback";
import { usePermission } from "../../../hooks/usePermission";
import Iconb from "../../extra/Iconb";
import ShowVideo from "../../extra/ShowVideo";
import LiveSellerDialogue from "./LiveSellerDialogue";



const Section = ({ title, children }) => (
  <div style={{
    border: "1px solid #eee",
    borderRadius: 8,
    padding: 10,
    marginTop: 12,
    fontSize: 13,
    background: "#fafafa"
  }}>
    <div style={{
      fontWeight: 600,
      marginBottom: 6,
      color: "#e91e63",
      fontSize: 12
    }}>
      {title}
    </div>
    <div style={{ lineHeight: 1.4 }}>
      {children}
    </div>
  </div>
);


const FakeSeller = (props) => {

  const { can } = usePermission();
  const canCreate = can("Seller", "Create");
  const canEdit = can("Seller", "Edit");
  const canDelete = can("Seller", "Delete");




  const [size, setSize] = useState(10);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  const [show, setShow] = useState(false);
  const [url, setUrl] = useState();

  const [openSellerModal, setOpenSellerModal] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(null);

  const { fakeSeller, totalSellers } = useSelector((state) => state.fakeSeller);

  const { dialogue, dialogueType } = useSelector(
    (state) => state.dialogue
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();



  useEffect(() => {
    dispatch(getFakeSeller(currentPage, size));
  }, [dispatch, currentPage, size]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Adjust the delay time as needed

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(fakeSeller);
  }, [fakeSeller]);

  // // pagination
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event), 10);
    setSize(parseInt(event), 10);
    setCurrentPage(1);
  };

  // const handleClick = (seller) => {
  //   
  //   props.sellerIsLive(seller, seller?.isLive === true ? false : true);
  // };

  const handleClick = (row) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: { data: row, type: "isLiveSelller" },
    })
  };



  // searching

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleOfflineClick = (id) => {

    dispatch(setOfflineStatus(id));
  };


  // Edit Fake Seller

  const handleEdit = (id) => {
    navigate("/admin/addFakeSeller", {
      state: id,
    });
  };


  // Delete FakeSeller
  const handleDelete = (id) => {


    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteFakeSeller(id);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleClose = () => {
    setShow(false);
    setUrl("");
  };

  const handleOpenSellerModal = (seller) => {
    setSelectedSeller(seller);
    setOpenSellerModal(true);
  };

  const handleCloseSellerModal = () => {
    setOpenSellerModal(false);
    setSelectedSeller(null);
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) =>
        <span className="text-white fw-normal">
          {(currentPage - 1) * rowsPerPage + index + 1}
        </span>,
    },
    {
      Header: "Seller",
      body: "firstName",
      Cell: ({ row }) => (
        <div className="d-flex">
          <div className="position-relative">
            {loading ? (
              <>
                <Skeleton
                  height={60}
                  width={60}
                  className="StripeElement "
                  baseColor={colors?.baseColor}
                  highlightColor={colors?.highlightColor}
                />
              </>
            ) : (
              <>
                <img
                  src={row?.image}
                  style={{
                    borderRadius: "10px",
                    objectFit: "cover",
                    boxSizing: "border-box",
                  }}
                  onClick={() => handleOpenSellerModal(row)}
                  height={60}
                  width={60}
                  alt=""
                />
              </>
            )}
          </div>
          <span className="boxCenter text-start ms-3">
            <b className="fw-normal text-white">
              {row?.firstName + " " + row?.lastName}
            </b>
          </span>
        </div>
      ),
      sorting: false,
    },

    // {
    //   Header: "Video",
    //   body: "video",
    //   Cell: ({ row }) => (
    //     <div className="position-relative">
    //       <video
    //         src={row?.video}
    //         controls
    //         style={{
    //           borderRadius: "10px",
    //           objectFit: "cover",
    //           boxSizing: "border-box",
    //         }}
    //         height={60}
    //         width={60}
    //         alt=""
    //       />
    //     </div>
    //   ),
    // },

    {
      Header: "VIDEO",
      body: "video",
      Cell: ({ row, index }) => (
        <>
          <div
            className="d-flex justify-content-center"
            onClick={() => {
              setShow(true);
              setUrl(row?.video);
            }}
          >
            {/* <HandleVideo thumbnail={row?.videoImage} videoUrl={row?.videoUrl} /> */}

            <div
              style={{
                position: "relative",
                width: "50px",
                height: "50px",
                cursor: "pointer",
              }}
            >
              <IconPlayerPlayFilled
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)", // centers it
                  zIndex: 1,
                  fontSize: "20px", // adjust size as needed
                  color: "white", // optional: make it visible
                }}
              />
              <LazyImage
                imageSrc={row?.image}
                width="50px"
                height="50px"
                style={{ filter: "brightness(0.5)" }}
              />
            </div>
          </div>
        </>
      ),
    },

    {
      Header: "Contact",
      body: "email",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-white fw-normal">{row?.email ? row?.email : "xyz@gmail.com"}</p>
          <p className="mb-0 text-white fw-normal">{row?.mobileNumber ? row?.mobileNumber : "-"}</p>
        </div>
      ),
      sorting: false,
    },
    {
      Header: "Business Name",
      body: "businessName",
      Cell: ({ row }) => (
        <span className="mb-0 text-white fw-normal">
          {row?.businessName ? row?.businessName : "-"}
        </span>
      ),
    },
    {
      Header: "Business Tag",
      body: "businessTag",
      Cell: ({ row }) => (
        <span className="mb-0 text-white fw-normal">{row.businessTag ? row.businessTag : "-"}</span>
      ),
    },

    {
      Header: "Created Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
      ),
    },

    ...(canEdit ? [
      {
        Header: "OnLive",
        body: "isLive",
        Cell: ({ row }) => (
          <div className="boxCenter">
            <svg
              onClick={() => handleClick(row)}
              width="26"
              height="29"
              viewBox="0 0 26 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 17C17 17.1725 16.9553 17.3421 16.8703 17.4923C16.7853 17.6425 16.6629 17.7681 16.515 17.857L11.515 20.857C11.3633 20.9485 11.1899 20.998 11.0128 21.0002C10.8356 21.0025 10.661 20.9576 10.507 20.87C10.3531 20.7827 10.2251 20.6563 10.136 20.5034C10.0469 20.3506 10 20.1769 10 20V14C10 13.823 10.047 13.6491 10.1362 13.4963C10.2254 13.3434 10.3536 13.2169 10.5076 13.1298C10.6617 13.0426 10.8361 12.9979 11.0131 13.0002C11.1901 13.0025 11.3633 13.0518 11.515 13.143L16.515 16.143C16.6629 16.2318 16.7853 16.3574 16.8703 16.5076C16.9553 16.6578 17 16.8274 17 17ZM26 14V20C26 24.962 21.962 29 17 29H9C4.038 29 0 24.962 0 20V14C0 9.28995 3.701 5.99995 9 5.99995H10.92L8.22 2.62495C8.13302 2.52309 8.06739 2.40478 8.027 2.27707C7.98662 2.14935 7.97231 2.01482 7.98491 1.88146C7.99752 1.74811 8.03679 1.61865 8.1004 1.50076C8.164 1.38287 8.25064 1.27897 8.35517 1.19521C8.4597 1.11145 8.58 1.04954 8.70891 1.01317C8.83783 0.976789 8.97274 0.966684 9.10564 0.98345C9.23853 1.00022 9.36671 1.04351 9.48255 1.11076C9.59839 1.17802 9.69954 1.26786 9.78 1.37495L13 5.39995L16.22 1.37495C16.3005 1.26786 16.4016 1.17802 16.5174 1.11076C16.6333 1.04351 16.7615 1.00022 16.8944 0.98345C17.0273 0.966684 17.1622 0.976789 17.2911 1.01317C17.42 1.04954 17.5403 1.11145 17.6448 1.19521C17.7494 1.27897 17.836 1.38287 17.8996 1.50076C17.9632 1.61865 18.0025 1.74811 18.0151 1.88146C18.0277 2.01482 18.0134 2.14935 17.973 2.27707C17.9326 2.40478 17.867 2.52309 17.78 2.62495L15.08 5.99995H17C22.299 5.99995 26 9.28995 26 14ZM24 14C24 9.85495 20.484 7.99995 17 7.99995H9C5.516 7.99995 2 9.85495 2 14V20C2 23.86 5.14 27 9 27H17C20.86 27 24 23.86 24 20V14Z"
                fill="black"
              />
            </svg>
          </div>
        ),
      }
    ] : []),


    // {
    //   Header: "OffLive",
    //   body: "is offline",
    //   Cell: ({ row }) => (
    //     <button
    //       className="btn btn-danger"
    //       style={{
    //         padding: "5px 7px"
    //       }}
    //       onClick={() => handleOfflineClick(row?._id)}
    //       disabled={row?.isLive === false ? true : false}
    //     >
    //       OffLive
    //     </button>
    //   ),
    // },

    // {
    //   Header: "OffLive",
    //   body: "is offline",
    //   Cell: ({ row }) => (
    //     <button
    //       className="btn btn-danger"
    //       style={{
    //         padding: "8px 16px",
    //         borderRadius: "12px",
    //         fontWeight: "600",
    //         fontSize: "14px",
    //         boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
    //         transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    //         opacity: row?.isLive === false ? 0.6 : 1,
    //         cursor: row?.isLive === false ? "not-allowed" : "pointer",
    //         userSelect: "none",
    //       }}
    //       onClick={() => handleOfflineClick(row?._id)}
    //       disabled={row?.isLive === false}
    //       onMouseEnter={e => {
    //         if (!row?.isLive === false) {
    //           e.currentTarget.style.backgroundColor = "#d6334f"; // darker red on hover
    //           e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.2)";
    //         }
    //       }}
    //       onMouseLeave={e => {
    //         e.currentTarget.style.backgroundColor = "";
    //         e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    //       }}
    //     >
    //       OffLive
    //     </button>
    //   ),
    // },

    ...(canEdit ? [
      {
        Header: "OffLive",
        body: "is offline",
        Cell: ({ row }) => (
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center"
            style={{
              borderRadius: "32px",
              fontWeight: "500",
              fontSize: "15px",
              padding: "8px 22px",
              gap: "8px",
              boxShadow: "0 2px 8px rgba(233, 51, 79, 0.10)",
              opacity: row?.isLive === false ? 0.6 : 1,
              cursor: row?.isLive === false ? "not-allowed" : "pointer",
              outline: "none",
              transition: "background .22s, box-shadow .22s"
            }}
            onClick={() => handleOfflineClick(row?._id)}
            disabled={row?.isLive === false}
            onMouseEnter={e => {
              if (row?.isLive !== false) {
                e.currentTarget.style.background = "#d62f48";
                e.currentTarget.style.boxShadow = "0 4px 16px rgba(233, 51, 79, 0.18)";
              }
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = "#FF4C51";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(233, 51, 79, 0.10)";
            }}
          >
            <MdOutlineLiveTv size={20} style={{ marginRight: "6px" }} /> OffLive
          </button>
        ),
      }
    ] : []),


    ...(canEdit ? [
      {
        Header: "Edit",
        body: "",
        Cell: ({ row }) => (
          <Iconb
            newClass={`themeFont boxCenter infobtn userBtn fs-5`}
            btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
            style={{
              borderRadius: "50px",
              margin: "auto",
              height: "45px",
              width: "45px",
              color: "#160d98",


            }}
            isImage={true}
            onClick={() => handleEdit(row)}

          />
        ),
      }
    ] : []),


    ...(canDelete ? [
      {
        Header: "Delete",
        body: "",
        Cell: ({ row }) => (
          <Iconb
            newClass={`themeFont boxCenter killbtn userBtn fs-5`}
            btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
            style={{
              borderRadius: "50px",
              margin: "auto",
              height: "45px",
              width: "45px",
              color: "#160d98",

              padding: "0px"

            }}
            isImage={true}
            isDeleted={true}
            onClick={() => handleDelete(row?._id)}

          />
        ),
      }
    ] : []),

    // add more columns as needed
  ];
  return (
    <>
      <ShowVideo
        title={"Video"}
        show={show}
        url={url}
        handleClose={handleClose}
      />
      <div className="mainSellerTable">
        <Modal open={openSellerModal} onClose={handleCloseSellerModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "65%",
              maxWidth: "700px",
              bgcolor: "#fff",
              borderRadius: "14px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              p: 2,
              maxHeight: "85vh",
              overflowY: "auto"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ fontSize: 18 }}>Seller Details</h3>

              <div
                onClick={handleCloseSellerModal}
                style={{
                  cursor: "pointer",
                  border: "1.5px solid #f06292",
                  borderRadius: "50%",
                  height: 24,
                  width: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f06292",
                  fontSize: 13,
                  fontWeight: "bold"
                }}
              >
                ✕
              </div>
            </div>

            {selectedSeller && (
              <>
                {/* PROFILE */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  border: "1px solid #eee",
                  padding: 12,
                  borderRadius: 10,
                  marginTop: 15
                }}>
                  <img
                    src={selectedSeller.image}
                    height={55}
                    width={55}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />

                  <div>
                    <h4 style={{ margin: 0, fontSize: 15 }}>
                      {selectedSeller.firstName} {selectedSeller.lastName}
                    </h4>
                    <span style={{
                      background: "#e91e63",
                      color: "#fff",
                      padding: "3px 12px",
                      borderRadius: 20,
                      fontSize: 10
                    }}>
                      Fake Seller
                    </span>
                  </div>
                </div>

                {/* DETAILS GRID */}
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 12,
                  marginTop: 15,
                  fontSize: 12
                }}>

                  <Section title="Personal Info">
                    <b>Email:</b> {selectedSeller.email}<br />
                    <b>Mobile:</b> {selectedSeller.mobileNumber}<br />
                    <b>Gender:</b> {selectedSeller.gender}
                  </Section>

                  <Section title="Business Info">
                    <b>Business:</b> {selectedSeller.businessName}<br />
                    <b>Tag:</b> {selectedSeller.businessTag}<br />
                    <b>Date:</b> {dayjs(selectedSeller.createdAt).format("DD MMM YYYY")}
                  </Section>

                  <Section title="Address">
                    <b>City:</b> {selectedSeller.address?.city}<br />
                    <b>State:</b> {selectedSeller.address?.state}<br />
                    <b>Country:</b> {selectedSeller.address?.country}
                  </Section>

                  <Section title="Bank">
                    <b>Bank:</b> {selectedSeller.bankDetails?.bankName}<br />
                    <b>Account:</b> {selectedSeller.bankDetails?.accountNumber}<br />
                    <b>IFSC:</b> {selectedSeller.bankDetails?.IFSCCode}
                  </Section>

                </div>
              </>
            )}
          </Box>
        </Modal>

        <div className="sellerTable">
          <div className="col-12 headname">Fake Seller </div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-2">
                    {canCreate && (
                      <Button
                        newClass={`whiteFont`}
                        // btnColor={`btnnewPrime`}
                        btnIcon={`fa-solid fa-plus`}
                        btnName={`Add`}
                        onClick={() => {

                          navigate("/admin/addFakeSeller");
                        }}
                        style={{ borderRadius: "5px", padding: "8px 32px", background: "#b93160" }}
                      />
                    )}

                    {dialogue && dialogueType === "isLiveSelller" && (
                      <LiveSellerDialogue />
                    )}

                  </div>
                  <div className="col-10 text-end">
                    <Searching
                      type={`client`}
                      data={fakeSeller}
                      setData={setData}
                      column={data}
                      onFilterData={handleFilterData}
                      serverSearching={handleFilterData}
                      button={true}
                      setSearchValue={setSearch}
                      searchValue={search}
                    />
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                serverPerPage={rowsPerPage}
                serverPage={page}
                type={"server"}
              />
              <Pagination
                component="div"
                count={totalSellers}
                type={"server"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={totalSellers}
                serverPage={currentPage}
                setCurrentPage={setCurrentPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getFakeSeller, deleteFakeSeller, sellerIsLive })(
  FakeSeller
);
// export default Seller;
